(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/header.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/header.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useContext,
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  productMapping,
  draws: {
    drawsApi,
    jackpotApi
  }
} = svs.numbergames;
const {
  BuyInInfo
} = svs.numbergames.fractiongames.components.gamecard;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const getJackpotTexts = _ref => {
  var _game$systemSize;
  let {
    productNumeric,
    drawNumber,
    game
  } = _ref;
  const descriptions = {
    [productMapping.CONSTANTS.LOTTO]: 'Drömvinsten',
    [productMapping.CONSTANTS.KENO]: 'Toppvinst',
    [productMapping.CONSTANTS.EUROJACKPOT]: 'Jackpot',
    [productMapping.CONSTANTS.VIKINGLOTTO]: 'Jackpot'
  };
  return {
    description: descriptions[productMapping.getProductId(productNumeric)],
    jackpotAmountStringShort: jackpotApi.jackpotAmountStringShort(_objectSpread({
      product: productNumeric,
      drawNumber
    }, productMapping.isKeno(productNumeric) && {
      kenoBoards: {
        kenoLevel: game.level,
        hasKungKeno: game.hasKungKeno,
        rowPrice: game.rowPrice * game.rowPriceMulti,
        systemNumbers: (_game$systemSize = game.systemSize) === null || _game$systemSize === void 0 ? void 0 : _game$systemSize.numbersSize,
        isSystem: true
      }
    }))
  };
};
const Header = () => {
  const {
    selectors
  } = useContext(ContainerContext);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const game = useSelector(selectors.selectGame);
  const drawNumber = drawsApi.drawNumber(productNumeric);
  const {
    jackpotAmountStringShort,
    description
  } = useMemo(() => getJackpotTexts({
    productNumeric,
    drawNumber,
    game
  }), [productNumeric, drawNumber, game]);
  return React.createElement("div", {
    className: "ng-fg-card-header secondary-card-header"
  }, React.createElement("p", {
    className: "fg-card-header-jackpot-info"
  }, "".concat(description, " ").concat(jackpotAmountStringShort)), React.createElement("div", {
    className: "fg-card-header-buy-in-info"
  }, React.createElement(BuyInInfo, null)));
};
svs.numbergames.fractiongames.components.gamecard.Header = Header;

 })(window);